"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update_user_facetec = update_user_facetec;
var firestore_1 = require("firebase/firestore");
var auth_1 = require("../../../features/slices/auth");
var user_profile_1 = require("../../../features/slices/user-profile");
var store_1 = require("../../../store");
var firebase_1 = require("../../../utils/firebase");
var user_state_1 = require("../../../utils/user-state");
// Update MongoDB via backend API
function updateFacetecInMongoDB(facetecDBRef) {
    return __awaiter(this, void 0, void 0, function () {
        var state, accessToken, apiUrl, response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    state = store_1.store.getState();
                    accessToken = state.auth.access_token;
                    if (!accessToken) {
                        return [2 /*return*/, false];
                    }
                    apiUrl = process.env.API_URL || "http://localhost:7002";
                    return [4 /*yield*/, fetch("".concat(apiUrl, "/v1/user/update-profile"), {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer ".concat(accessToken),
                            },
                            body: JSON.stringify({ facetecDBRef: facetecDBRef }),
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data.success === true];
                case 3:
                    error_1 = _a.sent();
                    console.error("Error saving FaceTec reference to MongoDB:", error_1);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function update_user_facetec(request) {
    return __awaiter(this, void 0, void 0, function () {
        var state, userState, firebaseUid, userDocRef, snap, userDocSnapshot, userProfile, error_2;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, , 6]);
                    state = store_1.store.getState();
                    userState = (0, user_state_1.getCurrentUserState)();
                    firebaseUid = ((_a = firebase_1.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid)
                        || state.auth.firebase_user_id
                        || localStorage.getItem("firebase_user_id")
                        || (userState === null || userState === void 0 ? void 0 : userState.uid)
                        || ((_c = (_b = state.userProfile) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.uid);
                    if (!firebaseUid) {
                        return [2 /*return*/, {
                                success: false,
                                message: "Failed to find user!",
                                content: null,
                            }];
                    }
                    userDocRef = (0, firestore_1.doc)(firebase_1.firestore, "users", firebaseUid);
                    if (!request.responseJSON.wasProcessed) return [3 /*break*/, 3];
                    // Update Firebase Doc
                    return [4 /*yield*/, (0, firestore_1.setDoc)(userDocRef, {
                            facetecDBRef: request.facetecDBRef,
                        }, { merge: true })];
                case 1:
                    // Update Firebase Doc
                    _d.sent();
                    // Update MongoDB via backend API (fire and forget)
                    updateFacetecInMongoDB(request.facetecDBRef);
                    // Persist to localStorage for quick access on page refresh
                    localStorage.setItem("facetecDBRef", request.facetecDBRef);
                    // Update Redux auth state with new FaceTec enrollment reference
                    store_1.store.dispatch((0, auth_1.setFacetecDBRef)(request.facetecDBRef));
                    // Also update the user profile state to keep them in sync
                    store_1.store.dispatch((0, user_profile_1.setProfileFacetecDBRef)(request.facetecDBRef));
                    (0, user_state_1.setAuthenticatedFacetec)(true, true);
                    return [4 /*yield*/, (0, firestore_1.getDoc)(userDocRef)];
                case 2:
                    snap = _d.sent();
                    if (snap.exists()) {
                        return [2 /*return*/, {
                                success: true,
                                message: "Account Updated",
                                content: __assign({ is_loading: false }, snap.data()),
                            }];
                    }
                    return [2 /*return*/, {
                            success: true,
                            message: "Enrollment saved",
                            content: { is_loading: false, facetecDBRef: request.facetecDBRef },
                        }];
                case 3: return [4 /*yield*/, (0, firestore_1.getDoc)(userDocRef)];
                case 4:
                    userDocSnapshot = _d.sent();
                    if (userDocSnapshot.exists()) {
                        userProfile = userDocSnapshot.data();
                        return [2 /*return*/, {
                                success: true,
                                message: "Account Updated",
                                content: __assign({ is_loading: false }, userProfile),
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                success: false,
                                message: "User profile not found",
                                content: null,
                            }];
                    }
                    return [3 /*break*/, 6];
                case 5:
                    error_2 = _d.sent();
                    console.error("Error updating FaceTec reference:", error_2);
                    return [2 /*return*/, {
                            success: false,
                            message: "Failed to update Facial Recognition reference",
                            content: null,
                        }];
                case 6: return [2 /*return*/];
            }
        });
    });
}
